/**
 * Image loading utilities (e.g. from blob URLs). Use with Texture.from(img) or similar in renderers.
 */

/** Loads an image from a URL (e.g. blob URL). Resolves to null on load/parse error instead of rejecting. */
export function loadImageFromBlobUrl(url: string): Promise<HTMLImageElement | null> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = url;
  });
}
